











































































































import { Component, Mixins, PropSync } from 'vue-property-decorator'
import InfoAlert from '@/components/familyPortal/checkout/infoAlert/InfoAlert.vue'
import APP_CONST from '@/constants/AppConst'
import { PaymentPlanInfo, PaymentPlans } from '@/Model/checkout/cart/types'
import { PaymentPlanInterval } from '@/utilities/paymentPlanInterval'
import { SessionEnrollmentStatus } from '@/Model/sessions/catalogTypes'
import AccountSettings from '@/mixins/accountSettings.mixin'
import cartStore from '@/store/modules/checkout/cart/module'

const paymentIntervalStrings: Record<PaymentPlanInterval, string> = {
  [PaymentPlanInterval.Weekly]: 'weekly',
  [PaymentPlanInterval.BiWeekly]: 'bi-weekly',
  [PaymentPlanInterval.Monthly]: 'monthly'
}

@Component({
  components: {
    InfoAlert
  }
})
export default class CheckoutPaymentPlanSelector extends Mixins(AccountSettings) {
  @PropSync('currentPaymentPlanSelection', { type: Number })
  currentPaymentPlanSelectionSync!: number
  public sessionPriceDecimalPrecision = APP_CONST.SESSION_PRICE_DECIMAL_PRECISION
  APP_CONST = APP_CONST

  get paymentPlanInfo(): PaymentPlanInfo | undefined {
    return cartStore.paymentPlanInfo
  }

  get sessionsStatus(): {
    hasWaitlist: boolean
    hasNonWaitlist: boolean
    hasAutoEnroll: boolean
    hasManualEnroll: boolean
    isBelowMinOrderAmount: boolean
  } {
    const hasWaitlist: boolean = this.paymentPlanInfo
      ? this.paymentPlanInfo.hasWaitlistSessions
      : false
    const hasNonWaitlist: boolean = cartStore.cartItems.some(
      (item) => item.session.sessionEnrollmentStatus !== SessionEnrollmentStatus.Waitlist
    )
    const hasAutoEnroll: boolean = this.paymentPlanInfo
      ? this.paymentPlanInfo.hasAutoEnrollmentSessions
      : false
    const hasManualEnroll: boolean = this.paymentPlanInfo
      ? this.paymentPlanInfo.hasManualSessions
      : false
    const isBelowMinOrderAmount: boolean = this.paymentPlanInfo
      ? this.paymentPlanInfo.isBelowMinOrderAmount
      : false

    return { hasWaitlist, hasNonWaitlist, hasAutoEnroll, hasManualEnroll, isBelowMinOrderAmount }
  }

  get infoAlertTitle(): string {
    if (this.paymentPlanInfo) {
      switch (true) {
        case this.sessionsStatus.isBelowMinOrderAmount:
          return 'Payment plans unavailable'
        case this.sessionsStatus.hasWaitlist:
          return 'Waitlist'
        case this.sessionsStatus.hasManualEnroll:
          return 'Payment schedule'
      }
    }
    return ''
  }

  get infoAlertDescription(): string {
    if (this.paymentPlanInfo) {
      switch (true) {
        case this.sessionsStatus.isBelowMinOrderAmount:
          return `Payment plans unavailable for orders under $${this.paymentPlanInfo && this.paymentPlanInfo.minOrderAmount}.`
        case this.sessionsStatus.hasWaitlist:
          return 'If enrolled in a session, your first payment will be due.'
        case this.sessionsStatus.hasManualEnroll:
          return 'First payment will be due when enrolled by the program admin.'
      }
    }
    return ''
  }

  get shouldShowInfoAlert(): boolean {
    return (
      this.sessionsStatus.isBelowMinOrderAmount ||
      this.sessionsStatus.hasWaitlist ||
      this.sessionsStatus.hasManualEnroll
    )
  }

  get shouldShowPaymentSchedule(): boolean {
    if (this.paymentPlanInfo) {
      return (
        this.sessionsStatus.hasNonWaitlist &&
        this.sessionsStatus.hasAutoEnroll &&
        !this.sessionsStatus.hasManualEnroll
      )
    }
    return false
  }

  paymentPlanSubtitle(paymentPlanItem: PaymentPlans): string {
    const paymentFrequency: number = paymentPlanItem.schedule ? paymentPlanItem.schedule.length : 0
    const paymentInterval: PaymentPlanInterval =
      paymentPlanItem.paymentInterval || PaymentPlanInterval.Weekly
    return this.shouldShowPaymentSchedule
      ? paymentPlanItem.subtitle
      : `Split the cost into ${paymentFrequency} ${paymentIntervalStrings[paymentInterval]} payments`
  }

  openPaymentScheduleModal(paymentPlanItem: PaymentPlans) {
    this.$emit('openPaymentScheduleModal', paymentPlanItem)
  }
}
